import { useEffect, useState } from 'react';
import { getCartItems } from '../../../../redux/features/cartSlice';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import { Box, Button, LinearProgress, Typography } from '@mui/material';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import { Icon } from '@iconify/react';
import { useLocation } from 'react-router-dom';

const PaymentCheckStatus = ({ paymentLink }) => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();

  useEffect(() => {
    let timer;

    if (open) {
      timer = setTimeout(() => {
        setOpen(false);

        dispatch(getCartItems(location?.state?.leadId)).then((res) => {
          if (res.payload.status === 'success') {
            enqueueSnackbar('Status checked successfully..', {
              variant: 'success',
            });
          } else {
            enqueueSnackbar('Something went wrong...', {
              variant: 'error',
            });
          }
        });
      }, 4000);
    }

    return () => clearTimeout(timer);
  }, [open]);

  return (
    <GlobalDialog
      open={open}
      setOpen={setOpen}
      title={'Check Status'}
      fullWidth
      closeButton={true}
      maxWidth={'md'}
      popupButton={
        paymentLink ? (
          <Button
            onClick={() => setOpen(true)}
            startIcon={<Icon icon="material-symbols-light:update" width="16" height="16" />}
            size="small"
          >
            Check Status
          </Button>
        ) : null
      }
      content={
        open && (
          <>
            <LinearProgress color="primary" sx={{ mb: 1 }} />
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Typography variant="body2">Please wait...</Typography>
            </Box>

            {paymentLink ? (
              <iframe
                src={paymentLink}
                title="Payment Status"
                style={{
                  width: '100%',
                  height: '600px',
                  border: 'none',
                  borderRadius: '8px',
                }}
              />
            ) : (
              <p style={{ textAlign: 'center', padding: '20px' }}>No unpaid payment found.</p>
            )}
          </>
        )
      }
    />
  );
};

export default PaymentCheckStatus;
